"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchNodeAssignableStatus = exports.getSpaceFeatures = exports.updateWorkbenchSetting = exports.updateMemberSetting = exports.deleteSubAdmin = exports.updateRole = exports.getSubUnitList = exports.getAllVisibleStatus = exports.updateAllVisible = exports.searchUnit = exports.editSubMember = exports.addSubMember = exports.searchMember = exports.subAdminPermission = exports.getlistRole = exports.changeMainAdmin = exports.getMainAdminInfo = exports.removeSpaceRedPoint = exports.getSpaceResource = exports.getSpaceNodeNumber = exports.searchSpaceSize = exports.recoverSpace = exports.spaceInfo = exports.updateSpace = exports.deleteSpaceNow = exports.deleteSpace = exports.switchSpace = exports.importFile = exports.allowVisiableSetting = exports.searchNode = exports.findNode = exports.quitSpace = exports.spaceList = exports.positionNode = exports.keepTabbar = exports.getDstId = exports.copyNode = exports.editNode = exports.getSpecifyNodeList = exports.delNode = exports.addNode = exports.nodeMove = exports.createSpace = exports.getRelateNodeByDstId = exports.getNodeListByParentId = exports.getNodeInfo = exports.getParents = exports.getChildNodeList = exports.getRootNode = exports.getNodeTree = void 0;
exports.checkoutOrder = exports.nodeShowcase = exports.updateShare = exports.getShareSettings = exports.regenerateShareLink = exports.disableShare = exports.storeShareData = exports.getEmbedLinkInfo = exports.readShareInfo = exports.changeNodeDesc = exports.getCapacityRewardList = void 0;
const axios_1 = __importDefault(require("axios"));
const config_1 = require("../../../config");
const urlcat_1 = __importDefault(require("urlcat"));
const Url = __importStar(require("../../shared/api/url"));
const CancelToken = axios_1.default.CancelToken;
/**
 *
 * Query the node tree of the workbench, limit the query to two layers
 *
 * @param depth
 * @returns
 */
function getNodeTree(depth) {
    return axios_1.default.get(Url.GET_NODE_TREE, {
        params: {
            depth,
        },
    });
}
exports.getNodeTree = getNodeTree;
/**
 *
 * Get and query the root node
 *
 * @returns
 */
function getRootNode() {
    return axios_1.default.get(Url.GET_ROOT_NODE);
}
exports.getRootNode = getRootNode;
/**
 *
 * Query the child node list
 *
 * @param nodeId
 * @param nodeType
 * @returns
 */
function getChildNodeList(nodeId, nodeType) {
    return axios_1.default.get(Url.GET_NODE_LIST, {
        params: {
            nodeId,
            nodeType
        },
    });
}
exports.getChildNodeList = getChildNodeList;
/**
 * Get Node's Parent Node List
 *
 * @param nodeId
 * @returns
 */
function getParents(nodeId) {
    return axios_1.default.get(Url.GET_PARENTS, {
        params: {
            nodeId,
        },
    });
}
exports.getParents = getParents;
/**
 *
 * Get Node Info
 *
 * @param nodeIds
 * @returns
 */
function getNodeInfo(nodeIds) {
    return axios_1.default.get(Url.GET_NODE_INFO, {
        params: {
            nodeIds,
        },
    });
}
exports.getNodeInfo = getNodeInfo;
/**
 * query the child nodes with the parent node id,
 *
 * @param parentId parent node id
 */
function getNodeListByParentId(parentId) {
    return axios_1.default.get(Url.SELECTBYPARENTID + parentId);
}
exports.getNodeListByParentId = getNodeListByParentId;
/**
 *
 * Get relevant nodes(form/mirror) of the node
 *
 * @param dstId datasheet id
 * @param viewId view id. if empty, query all views' relevant nodes.
 * @param type   relevant nodes type. if empty, query all types.
 */
function getRelateNodeByDstId(dstId, viewId, type) {
    return axios_1.default.get(Url.DATASHEET_FOREIGN_FORM, {
        params: {
            nodeId: dstId,
            viewId,
            type,
        },
    });
}
exports.getRelateNodeByDstId = getRelateNodeByDstId;
/**
 * Create Space
 *
 * @param name Space Name
 */
function createSpace(name) {
    return axios_1.default.post(Url.CREATE_SPACE, {
        name,
    });
}
exports.createSpace = createSpace;
/**
 * Move Nodes
 *
 * @param nodeId the node id that will be moved.
 * @param parentId the parent node id that will be placed here.
 * @param preNodeId
 */
function nodeMove(nodeId, parentId, preNodeId) {
    return axios_1.default.post(Url.MOVE_NODE, {
        nodeId,
        parentId,
        preNodeId,
    });
}
exports.nodeMove = nodeMove;
/**
 * Add Node
 */
function addNode(nodeInfo) {
    return axios_1.default.post(Url.ADD_NODE, nodeInfo);
}
exports.addNode = addNode;
/**
 * Delete Node
 * @param nodeId Node Id
 */
function delNode(nodeId) {
    return axios_1.default.delete(Url.DELETE_NODE + nodeId);
}
exports.delNode = delNode;
function getSpecifyNodeList(nodeType) {
    return axios_1.default.get(Url.GET_SPECIFY_NODE_LIST, {
        params: {
            type: nodeType,
        },
    });
}
exports.getSpecifyNodeList = getSpecifyNodeList;
/**
 * Edit Node
 *
 * @param nodeId Node ID
 * @param data
 */
function editNode(nodeId, data) {
    return axios_1.default.post(Url.EDIT_NODE + nodeId, data);
}
exports.editNode = editNode;
/**
 * duplicate the node
 *
 */
function copyNode(nodeId, copyAll) {
    return axios_1.default.post(Url.COPY_NODE, {
        nodeId,
        data: copyAll,
    });
}
exports.copyNode = copyNode;
/**
 * Get Datasheet ID by Node ID
 *
 * @param nodeId Node ID
 */
function getDstId(nodeId) {
    return axios_1.default.get(Url.GET_DST_ID + nodeId);
}
exports.getDstId = getDstId;
/**
 * Save the active datasheet tab
 */
function keepTabbar(data) {
    return axios_1.default.post(Url.KEEP_TAB_BAR, data);
}
exports.keepTabbar = keepTabbar;
/**
 * Positioning the node, where it is.
 */
function positionNode(nodeId) {
    return axios_1.default.get(Url.POSITION_NODE + nodeId);
}
exports.positionNode = positionNode;
/**
 * Get space list
 */
function spaceList(onlyManageable) {
    return axios_1.default.get(Url.SPACE_LIST, { params: { onlyManageable } });
}
exports.spaceList = spaceList;
/**
 * Quit the Space
 * @param spaceId
 */
function quitSpace(spaceId) {
    return axios_1.default.post(`${Url.QUIT_SPACE}${spaceId}`);
}
exports.quitSpace = quitSpace;
/**
 * Find nodes
 *
 * @param keyword the keyword to search
 */
function findNode(keyword, ctx) {
    return axios_1.default.get(Url.SEARCH_NODE, {
        params: {
            keyword,
        },
        cancelToken: new CancelToken(ctx),
    });
}
exports.findNode = findNode;
/**
 * Search nodes
 *
 * @param spaceId
 * @param keyword
 * @returns
 */
function searchNode(spaceId, keyword) {
    return axios_1.default.get(Url.SEARCH_NODE, {
        params: {
            spaceId,
            keyword,
        },
    });
}
exports.searchNode = searchNode;
/**
 * Get the setting of "whether the space is visible to all members"
 * @param nodeId current node id
 */
function allowVisiableSetting(nodeId) {
    return axios_1.default.get(Url.ALLOW_VISIBLE_SETTING, {
        params: {
            nodeId,
        },
    });
}
exports.allowVisiableSetting = allowVisiableSetting;
/**
 *
 * import datasheet by file
 *
 * @param formData
 * @param onUploadProgress
 * @param ctx
 * @returns
 */
function importFile(formData, onUploadProgress, ctx) {
    return axios_1.default.post(Url.IMPORT_FILE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        cancelToken: new CancelToken(ctx),
        onUploadProgress,
    });
}
exports.importFile = importFile;
/**
 * Switch Space
 * @param spaceId
 * @returns
 */
function switchSpace(spaceId) {
    return axios_1.default.post((0, urlcat_1.default)(Url.SWITCH_SPACE, { spaceId }));
}
exports.switchSpace = switchSpace;
/**
 * Delete Space
 *
 * @param spaceId
 * @param code
 * @param type
 * @returns
 */
function deleteSpace(spaceId, code, type) {
    return axios_1.default.delete((0, urlcat_1.default)(Url.DELETE_SPACE, { spaceId }), {
        data: {
            code,
            type,
        },
    });
}
exports.deleteSpace = deleteSpace;
/**
 *
 * Delete the space immediately
 *
 * @returns
 */
function deleteSpaceNow() {
    return axios_1.default.delete(Url.DELETE_SPACE_NOW);
}
exports.deleteSpaceNow = deleteSpaceNow;
/**
 * Update/Edit the space
 *
 * @param name
 * @param logo
 */
function updateSpace(name, logo) {
    return axios_1.default.post(Url.UPDATE_SPACE, {
        name,
        logo,
    });
}
exports.updateSpace = updateSpace;
/**
 * Get space info
 *
 * @param spaceId
 * @returns
 */
function spaceInfo(spaceId) {
    return axios_1.default.get(Url.SPACE_INFO + spaceId);
}
exports.spaceInfo = spaceInfo;
/**
 * Recover space
 *
 * @param spaceId
 * @returns
 */
function recoverSpace(spaceId) {
    return axios_1.default.post(Url.RECOVER_SPACE + spaceId);
}
exports.recoverSpace = recoverSpace;
/**
 * Search space size
 * @returns
 */
function searchSpaceSize() {
    return axios_1.default.get(Url.SPACE_MEMORY);
}
exports.searchSpaceSize = searchSpaceSize;
/**
 * Get the number of nodes(folders and files) in the specified space
 * @param spaceId
 */
function getSpaceNodeNumber() {
    return axios_1.default.get(Url.NODE_NUMBER);
}
exports.getSpaceNodeNumber = getSpaceNodeNumber;
/**
 * Get the permissions resources of the specified space
 * @param spaceId
 */
function getSpaceResource() {
    return axios_1.default.get(Url.SPACE_RESOURCE);
}
exports.getSpaceResource = getSpaceResource;
/**
 * clean the red dot of space
 * @param spaceId
 */
function removeSpaceRedPoint(spaceId) {
    return axios_1.default.post(`${Url.REMOVE_RED_POINT}${spaceId}`);
}
exports.removeSpaceRedPoint = removeSpaceRedPoint;
/**
 * get main admin info
 */
function getMainAdminInfo() {
    return axios_1.default.get(Url.MAIN_ADMIN_INFO);
}
exports.getMainAdminInfo = getMainAdminInfo;
/**
 * change main admin
 */
function changeMainAdmin(memberId) {
    return axios_1.default.post(Url.CHANGE_MAIN_ADMIN, { memberId });
}
exports.changeMainAdmin = changeMainAdmin;
/**
 * query the list of admins
 *
 * @param pageObjectParams pagination params
 */
function getlistRole(pageObjectParams) {
    return axios_1.default.get(Url.LIST_ROLE, {
        params: {
            pageObjectParams,
        },
    });
}
exports.getlistRole = getlistRole;
/**
 * get sub-admin's permission
 */
function subAdminPermission(memberId) {
    return axios_1.default.get(Url.SUB_ADMIN_PERMISSION, {
        params: {
            memberId,
        },
    });
}
exports.subAdminPermission = subAdminPermission;
/**
 * fuzzy search members
 *
 * @param keyword the keyword to search
 */
function searchMember(keyword, filter) {
    return axios_1.default.get(Url.MEMBER_SEARCH, {
        params: {
            keyword,
            filter,
        },
    });
}
exports.searchMember = searchMember;
/**
 * add sub-admin
 *
 * @param memberId member id
 * @param resourceCodes operation resources set, no orders, auto verify
 */
function addSubMember(memberIds, resourceCodes) {
    return axios_1.default.post(Url.ADD_SUB_ADMIN, {
        memberIds,
        resourceCodes,
    });
}
exports.addSubMember = addSubMember;
/**
 * edit sub-admin
 *
 * @param memberId member id
 * @param resourceCodes operation resources set, no orders, auto verify
 */
function editSubMember(id, memberId, resourceCodes) {
    return axios_1.default.post(Url.EDIT_SUB_ADMIN, {
        id,
        memberId,
        resourceCodes,
    });
}
exports.editSubMember = editSubMember;
/**
 * search organization resource
 *
 * @param keyword keywords(tag/team)
 */
function searchUnit(keyword, linkId) {
    return axios_1.default.get(Url.SEARCH_UNIT, {
        params: {
            keyword,
            linkId,
        },
    });
}
exports.searchUnit = searchUnit;
/**
 * update the all visibility of the current space
 */
function updateAllVisible() {
    return axios_1.default.post(Url.UPDATE_ALL_VISIBLE);
}
exports.updateAllVisible = updateAllVisible;
/**
 * get all visible status of the current space
 */
function getAllVisibleStatus() {
    return axios_1.default.get(Url.GET_ALL_VISIBLE);
}
exports.getAllVisibleStatus = getAllVisibleStatus;
/**
 * get child teams and members
 * @param teamId Team ID
 */
function getSubUnitList(teamId, linkId) {
    return axios_1.default.get(Url.GET_SUB_UNIT_LIST, {
        params: {
            teamId,
            linkId,
        },
    });
}
exports.getSubUnitList = getSubUnitList;
/**
 * Update(edit) role
 *
 * @param data data info
 */
function updateRole(data) {
    return axios_1.default.post(Url.UPDATE_ROLE, data);
}
exports.updateRole = updateRole;
/**
 * delete sub-admin
 */
function deleteSubAdmin(memberId) {
    return axios_1.default.delete(Url.DELETE_SUB_ADMIN + memberId);
}
exports.deleteSubAdmin = deleteSubAdmin;
/**
 * update member setting
 */
function updateMemberSetting(data) {
    return axios_1.default.post(Url.UPDATE_MEMBER_SETTING, Object.assign({}, data));
}
exports.updateMemberSetting = updateMemberSetting;
/**
 * update workbench setting
 */
function updateWorkbenchSetting(data) {
    return axios_1.default.post(Url.UPDATE_WORKBENCH_SETTING, Object.assign({}, data));
}
exports.updateWorkbenchSetting = updateWorkbenchSetting;
/**
 * get space features
 */
function getSpaceFeatures() {
    return axios_1.default.get(Url.GET_SPACE_FEATURES);
}
exports.getSpaceFeatures = getSpaceFeatures;
/**
 * switch the status of the node role assignment
 */
function switchNodeAssignableStatus() {
    return axios_1.default.post(Url.SWITCH_NODEROLE_ASSIGNALE);
}
exports.switchNodeAssignableStatus = switchNodeAssignableStatus;
/**
 * Get Space Reward infos
 *
 * @param isExpire
 * @param pageNo
 * @returns
 */
function getCapacityRewardList(isExpire, pageNo) {
    const pageObjectParams = JSON.stringify({
        pageSize: config_1.ConfigConstant.CAPACITY_REWARD_LIST_PAGE_SIZE,
        order: 'createdAt',
        sort: config_1.ConfigConstant.SORT_DESC,
        pageNo,
    });
    return axios_1.default.get(Url.CAPACITY_REWARD_LIST, {
        params: {
            pageObjectParams,
            isExpire,
        },
    });
}
exports.getCapacityRewardList = getCapacityRewardList;
/**
 * change node's description
 *
 * @param nodeId
 * @param desc
 * @returns
 */
function changeNodeDesc(nodeId, desc) {
    return axios_1.default.post(Url.CHANGE_NODE_DESC, {
        nodeId,
        description: desc,
    });
}
exports.changeNodeDesc = changeNodeDesc;
function readShareInfo(shareId, headers) {
    return axios_1.default.get(Url.READ_SHARE_INFO + `/${shareId}`, {
        headers,
    });
}
exports.readShareInfo = readShareInfo;
/**
 * get embed Info
 */
const baseURL = process.env.NEXT_PUBLIC_NEXT_API;
function getEmbedLinkInfo(linkId, headers) {
    return axios_1.default.get(Url.EMBED_LINK_INFO + `/${linkId}`, {
        baseURL,
        headers,
    });
}
exports.getEmbedLinkInfo = getEmbedLinkInfo;
function storeShareData(shareId, spaceId) {
    return axios_1.default.post(Url.STORE_SHARE_DATA, {
        spaceId,
        shareId,
    });
}
exports.storeShareData = storeShareData;
/**
 * disable the node's share link
 *
 * @export
 * @param {string} nodeId
 * @returns
 */
function disableShare(nodeId) {
    return axios_1.default.post(Url.DISABLE_SHARE + nodeId);
}
exports.disableShare = disableShare;
/**
 * refresh node's share link
 *
 * @export
 * @param {string} nodeId
 * @returns
 */
function regenerateShareLink(nodeId) {
    return axios_1.default.post(Url.REGENERATE_SHARE_LINK + nodeId);
}
exports.regenerateShareLink = regenerateShareLink;
/**
 * get node's share setting
 *
 * @export
 * @param {string} nodeId
 * @returns
 */
function getShareSettings(nodeId) {
    return axios_1.default.get(Url.SHARE_SETTINGS + nodeId);
}
exports.getShareSettings = getShareSettings;
function updateShare(nodeId, permission) {
    return axios_1.default.post(Url.UPDATE_SHARE + nodeId, {
        props: JSON.stringify(permission),
    });
}
exports.updateShare = updateShare;
/**
 * folder node preview
 *
 * @param nodeId
 */
function nodeShowcase(nodeId, shareId) {
    return axios_1.default.get(Url.NODE_SHOWCASE, {
        params: {
            nodeId,
            shareId,
        },
    });
}
exports.nodeShowcase = nodeShowcase;
function checkoutOrder(spaceId, priceId, clientReferenceId, couponId) {
    return axios_1.default.post(Url.CHECKOUT_ORDER, {
        spaceId,
        priceId,
        clientReferenceId,
        couponId
    });
}
exports.checkoutOrder = checkoutOrder;
//# sourceMappingURL=api.space.js.map